import React, { useState } from "react";
import LoadingOverlay from "../LoadingOverlay";
import DetailPageHeader from "./DetailPageHeader";
import DetailPageActions from "./DetailPageActions";
import DetailContentPanel from "./DetailContentPanel";
import DetailInfoSidebar from "./DetailInfoSidebar";
import ConfirmDeleteModal from "./ConfirmDeleteModal";

export default function DetailPageLayout({
  title,
  subtitle,
  breadcrumbs = [],
  listPath,
  imageUrl,
  contentSections = [],
  infoItems = [],
  infoTitle = "Article Information",
  quickActions = [],
  editPath,
  onEdit,
  onRemove,
  footerStart,
  loading = false,
  removeMessage,
  children,
}) {
  const [openRemove, setOpenRemove] = useState(false);

  if (loading) {
    return <LoadingOverlay message="Loading details..." />;
  }

  const handleConfirmRemove = async () => {
    setOpenRemove(false);
    if (onRemove) {
      await onRemove();
    }
  };

  return (
    <div className="detail-page">
      <DetailPageHeader
        breadcrumbs={breadcrumbs}
        title={title}
        subtitle={subtitle}
        listPath={listPath}
      />

      <div className="detail-page-main">
        {children || (
          <div className="detail-body">
            <DetailContentPanel imageUrl={imageUrl} sections={contentSections} />
            <DetailInfoSidebar
              infoTitle={infoTitle}
              infoItems={infoItems}
              quickActions={quickActions}
            />
          </div>
        )}
      </div>

      <DetailPageActions
        editPath={editPath}
        onEdit={onEdit}
        footerStart={footerStart}
        onRemove={onRemove ? () => setOpenRemove(true) : undefined}
      />

      <ConfirmDeleteModal
        open={openRemove}
        onClose={() => setOpenRemove(false)}
        onConfirm={handleConfirmRemove}
        message={removeMessage}
      />
    </div>
  );
}
